import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

import logo from '../../assets/images/logo-gs.png';

import { useLocation } from 'react-router';

const Navbar = () => {
	const location = useLocation();
	let isHomePage = false;

	if (location.pathname === '/') {
		isHomePage = true;
	}

	return (
		<nav
			className={'Navbar  TextShadow'}
			style={{
				boxShadow:
					location.pathname === '/'
						? ''
						: '0 2px 8px hsla(150, 0%, 2%, 100%)',
				borderBottom:
					location.pathname === '/'
						? 'solid #fff 1px'
						: 'solid #fff 1px',
			}}
		>
			<NavLink
				to="/"
				className="Navbar__Company aspects__navbar-logo-link"
			>
				<img className="Navbar__CompanyLogo" src={logo} />
				<div className="Navbar__Name">
					<div className="Navbar__CompanyName">Aspects of Nature</div>
					<div className="Navbar__ArtistName">
						Daniela Pessotto-Robba
					</div>
				</div>
			</NavLink>
			<input
				type="checkbox"
				id="Navbar__MenuToggle"
				className="Navbar__MenuToggle"
				hidden
			></input>
			<ul>
				<li>
					<NavLink
						to="/"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						Home
					</NavLink>
				</li>
				<li>
					<NavLink
						to="/about"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						About
					</NavLink>
				</li>
				<li>
					<NavLink
						to="/products"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						Products
					</NavLink>
					<ul>
						<li>
							<NavLink
								to="/greetingcards"
								className="Navbar__ProductPage"
							>
								Greeting Cards
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/magnets"
								className="Navbar__ProductPage"
							>
								Magnets
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/bookmarks"
								className="Navbar__ProductPage"
							>
								Bookmarks
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/coasters"
								className="Navbar__ProductPage"
							>
								Coasters
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/stubbyholders"
								className="Navbar__ProductPage"
							>
								Stubby Holders
							</NavLink>
						</li>
						<li>
							<NavLink
								to="/clips"
								className="Navbar__ProductPage"
							>
								Clips
							</NavLink>
						</li>
						<li>
							<NavLink to="/pens" className="Navbar__ProductPage">
								Pens
							</NavLink>
						</li>
					</ul>
				</li>
				<li>
					<NavLink
						to="/contact"
						className={({ isActive }) =>
							isActive
								? 'Navbar__MainPageLink Navbar__CurrentPage'
								: 'Navbar__MainPageLink'
						}
					>
						Contact
					</NavLink>
				</li>
				<li>
					<a
						href="https://www.instagram.com/aspectsofnature8"
						role="button"
					>
						<FontAwesomeIcon icon={faInstagram} size="2x" />
					</a>
				</li>
			</ul>

			<label
				htmlFor="Navbar__MenuToggle"
				className="Navbar__MenuToggleLabel"
			>
				<div className="Navbar__Menu" type="checkbox">
					<div className="Navbar__MenuTop"></div>
					<div className="Navbar__MenuMid"></div>
					<div className="Navbar__MenuBottom"></div>
				</div>
			</label>
		</nav>
	);
};

export default Navbar;
